import React from 'react';
import PropTypes from 'prop-types';
import {
  ScrollView,
  View,
  Image,
  Text,
  TouchableOpacity,
} from 'react-native';
import { ifIphoneX } from 'react-native-iphone-x-helper';

import PendingImage from '../misc/PendingImage';
import AORTypes from '../../types';
import styles from '../../styles';
import PublisherBadge from '../apps/PublisherBadge';
import face from '../../assets/images/glyphicons-camera.png';
import { translate } from '../../locales/i18n';

import MenuExpanded from '../../assets/images/menu_expanded.svg';
import MenuCollapsed from '../../assets/images/menu_collapsed.svg';

class Menu extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
    };
  }

  render() {
    const {
      onItemSelected, user, userData, direction,
      getItems,
    } = this.props;

    // console.log(userData);

    let image = null;
    let hasImage = false;
    if (userData && userData.image) {
      image = PublisherBadge.getImage(userData.image);
      hasImage = true;
    }

    // console.log(user);

    const xHack = ifIphoneX(direction === 'row' ? {
      paddingLeft: 40,
    } : {}, {
    });

    const items = getItems(user);

    return (
      <ScrollView key="menu" scrollsToTop={false} style={styles.nav.menu}>
        <View
          key="profile"
          style={[items.style, xHack]}
        >
          <Text
            onPress={() => onItemSelected(items.modeSwitchLink)}
            style={styles.nav.switch}
          >
            {items.modeSwitchText}
          </Text>
          {userData && userData.auditor && (
            <Text
              onPress={() => onItemSelected('/auditor')}
              style={{ ...styles.nav.switch, marginTop: 20 }}
            >
              {translate('menu_mode_auditor')}
            </Text>
          )}
          {user ? (
            <TouchableOpacity
              accessibilityRole="link"
              // href="/profile"
              style={styles.nav.avatarTouchable}
              onPress={() => onItemSelected('/profile')}
            >
              {hasImage && image ? (
                <PendingImage
                  // key={(userData && userData.image) || 'none'}
                  imageStyle={hasImage ? styles.nav.avatar : styles.nav.avatarDefault}
                  activityIndicatorStyle={hasImage ? styles.nav.avatar : styles.nav.avatarDefault}
                  source={image}
                />
              ) : (
                <Image
                  // key={(userData && userData.image) || 'none'}
                  style={hasImage ? styles.nav.avatar : styles.nav.avatarDefault}
                  source={face}
                />
              )}
              <View
                style={{
                  flexDirection: 'column',
                }}
              >
                {user.attributes.preferred_username && (
                  <Text
                    style={styles.nav.name}
                    numberOfLines={1}
                    ellipsizeMode="tail"
                  >
                    {user.attributes.preferred_username}
                  </Text>
                )}
                <Text
                  style={styles.nav.email}
                  numberOfLines={1}
                  ellipsizeMode="tail"
                >
                  {user.attributes.email}
                </Text>
              </View>
            </TouchableOpacity>
          ) : [
          ]}
        </View>

        {!user && (
          <View
            key="signin"
            style={styles.nav.itemTop}
          >
            <TouchableOpacity
              accessibilityRole="link"
              // href="/signin"
              onPress={() => onItemSelected('/signin')}
              style={styles.nav.itemLink}
            >
              <Text
                style={styles.nav.itemText}
              >
                {translate('menu_signin')}
              </Text>
            </TouchableOpacity>
          </View>
        )}
        {/* {!user && (
          <Text
            key="signup"
            onPress={() => onItemSelected('/signup')}
            style={[styles.nav.item, xHack]}
          >
            {translate('menu_signup')}
          </Text>
        )} */}

        {items.mainMenuItems.map((item, idx) => (
          <View
            key={item.text}
            style={[(user && idx === 0) ? styles.nav.itemTop : styles.nav.item, xHack]}
          >
            <TouchableOpacity
              accessibilityRole="link"
              // href={item.link}
              onPress={() => onItemSelected(item.link)}
              style={styles.nav.itemLink}
            >
              <Text
                style={styles.nav.itemText}
              >
                {item.text}
              </Text>
            </TouchableOpacity>
          </View>
        ))}

        {items.collapsableMenuItems.map((collapsableItem) => {
          const newState = {};

          const isExpanded = this.state[collapsableItem.stateName]; // eslint-disable-line react/destructuring-assignment
          newState[collapsableItem.stateName] = !isExpanded;

          return (
            <View
              key={collapsableItem.text}
            >
              <TouchableOpacity
                style={[styles.nav.item, xHack]}
                onPress={() => { this.setState(newState); }}
              >
                <Text
                  key={collapsableItem.text}
                  // key={`chapter${idx}`} // eslint-disable-line react/no-array-index-key
                  style={styles.nav.itemText}
                >
                  {collapsableItem.text}
                </Text>
                {isExpanded ? (
                  <MenuExpanded key="expanded" />
                ) : (
                  <MenuCollapsed key="collapsed" />
                )}
              </TouchableOpacity>
              {collapsableItem.items.map((item) => (
                <View
                  key={item.text}
                  style={[isExpanded ? styles.nav.item2 : styles.nav.item2hidden, xHack]}
                >
                  <TouchableOpacity
                    accessibilityRole="link"
                    // href={item.link}
                    onPress={() => onItemSelected(item.link)}
                    style={styles.nav.itemLink}
                  >
                    <Text
                      style={styles.nav.item2Text}
                    >
                      {item.text}
                    </Text>
                  </TouchableOpacity>
                </View>
              ))}
            </View>
          );
        })}
      </ScrollView>
    );
  }
}

Menu.defaultProps = {
  user: null,
  userData: null,
};

Menu.propTypes = {
  direction: PropTypes.string.isRequired,
  user: AORTypes.AWS.Cognito.User,
  userData: AORTypes.User,
  onItemSelected: PropTypes.func.isRequired,
  getItems: PropTypes.func.isRequired,
};

export default Menu;
